// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PCLtR","newExpiryDate":"styles_newExpiryDate__3nrqY","footer":"styles_footer__3AG5F"};